import { Wizard } from "@/components/templates/Wizard";
import useActiveSelfInitiableMeasuredQuestionnaire from "@/hooks/useActiveSelfInitiableMeasuredQuestionnaire";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId/wizard")({
  component: WizardPage,
});

function WizardPage() {
  const { organizationKey, dossierId, researchProjectId } = Route.useParams();
  const navigate = useNavigate();
  const { hasActive, loading, error } = useActiveSelfInitiableMeasuredQuestionnaire(researchProjectId);

  useEffect(() => {
    if (hasActive) {
      void navigate({
        to: "/$organizationKey/$dossierId/$researchProjectId",
        params: { organizationKey, dossierId, researchProjectId },
        replace: true,
      });
    }
  }, [hasActive, navigate, organizationKey, dossierId, researchProjectId]);

  if (loading) return <div></div>;
  if (error) return <div>Error: {error.message}</div>;
  if (hasActive) return null;

  return <Wizard researchProjectId={Number.parseInt(researchProjectId)} />;
}
